import { Option } from './types';

export type SelectOptionsFromQueryOptionsType = {
  dataFieldName?: string;
  valueFieldName?: string;
  labelFieldName?: string;
  copyAllItemFields?: boolean;
};

export type SelectOptionsFromQueryReturnType = {
  values: Option[];
  count: number;
};

export const getSelectOptionsFromQuery = (
  queryResult: any,
  options?: SelectOptionsFromQueryOptionsType
): SelectOptionsFromQueryReturnType => {
  const { loading, error, data } = queryResult;

  var result: SelectOptionsFromQueryReturnType = {
    values: [],
    count: 0,
  };

  if (loading || error || !data) return result;

  const dataFieldName: string = options && options.dataFieldName ? options.dataFieldName : Object.keys(data)[0];
  const dataField: any = data[dataFieldName];
  if (dataField === null || dataField === undefined) return result;

  const copyAllItemFields = options && options.copyAllItemFields ? true : false;
  const valueFieldName = options && options.valueFieldName ? options.valueFieldName : 'id';
  const labelFieldName = options && options.labelFieldName ? options.labelFieldName : 'name';

  if (dataField['edges'] !== undefined) {
    result.values = dataField['edges'].map((edge: any) => {
      const option = {
        ...(copyAllItemFields ? edge.node : {}),
        label: edge.node[labelFieldName] as string,
        value: edge.node[valueFieldName] as string,
      };
      delete option.__typename;
      return option;
    });
    result.count = dataField['aggregate'] !== undefined ? dataField['aggregate'].count : -1;
    return result;
  }

  result.values = dataField.map((item: any) => {
    const option = {
      ...(copyAllItemFields ? item : {}),
      label: item[labelFieldName] as string,
      value: item[valueFieldName] as string,
    };
    delete option.__typename;
    return option;
  });
  result.count = dataField.length;
  return result;
};

export const getQueryTotalResultCount = (queryResult: any, options?: SelectOptionsFromQueryOptionsType): number => {
  const { loading, error, data } = queryResult;
  if (loading || error || !data) return 0;

  const dataFieldName: string = options && options.dataFieldName ? options.dataFieldName : Object.keys(data)[0];
  const dataField: any = data[dataFieldName];
  if (dataField === null || dataField === undefined) return 0;

  if (dataField['aggregate'] !== undefined) {
    return dataField['aggregate'].count;
  }

  return dataField.length;
};

export type SelectScrollHandlerForQueryOptionsType = {
  dataFieldName?: string;
};

export const selectScrollHandlerForQuery = (
  queryResult: any,
  variables?: any,
  options?: SelectScrollHandlerForQueryOptionsType
) => {
  const { data, fetchMore } = queryResult;
  const dataFieldName: string = options && options.dataFieldName ? options.dataFieldName : Object.keys(data)[0];
  const dataField: any = data[dataFieldName];

  if (!(dataField && dataField.pageInfo && dataField.pageInfo.hasNextPage)) return;

  const moreVariables: any = {
    input: {},
    ...(!!variables ? variables : {}),
  };
  moreVariables.input.after = dataField && dataField.pageInfo && dataField.pageInfo.endCursor;

  fetchMore({
    variables: moreVariables,
    updateQuery: (previousResult: any, param: any) => {
      const { fetchMoreResult } = param;
      const moreDataField: any = fetchMoreResult[dataFieldName];
      const prevDataField: any = previousResult[dataFieldName];
      const result = {};
      result[dataFieldName] = {
        aggregate: moreDataField.aggregate,
        pageInfo: moreDataField.pageInfo,
        edges: [...prevDataField.edges, ...moreDataField.edges],
        __typename: moreDataField.__typename,
      };
      return result;
    },
  });
};
